export const Constants = {
  BANNER_HEADING: "Welcome to the User Administration",
  BANNER_PARAGRAPH:
    "CPQ platform! Simplify your process with intuitive, powerful, and customizable Configure-Price-Quote solution",
  BREADCRUMB_NAME: "Manage Users",
  SEARCHPLACEHOLDER: "Search by name, role etc",
  USERS: "Users",
  ROLE: "Roles",
  ROLES: "User Roles",
  ADDUSER: "Add User",
  EDITUSER: "Edit User",
  ADDROLE: "Add Role",
  EDITROLE: "Edit Role",
  ACTION: "Action",
  USERSORTROW: "firstName",
  ROLESORTROW: "role",
  PAGENUMBER: 1,
  ASENDING: "asc",
  DECENDING: "desc",
  VIEW: "View",
  PRIVILEGE: "Privilege",
  EMAIL: "Email",
  FIRSTNAME: "First Name",
  LASTNAME: "Last Name",
  ROLE: " User Roles",
ROLEFIELD:"Role",
  STATUS: "Status",
  OK: "Ok",
  STRING: "string",
  VIEWHEADING: "Role have following Privileges:",
  EMAILREQUIRED: "Email is required",
  STATUSISREQUIRED: "Status is required",
  ROLEISREQUIRED: "Role is required",
  ROLEDESCRIPTIONREQUIRED:"Role description is required",
  MAXLENGTH: "Role name must not exceed 50 characters",
  PRIVILEGESISREQUIRED: "Privileges are required",
  FETCH: " Fetch Info",
  EMAILVALIDATION: "Please enter a valid E-mail address.",
  USEREXISTS: "User already exists",
  USEREMAILCHANGED: "User Email changed.Click fetch info.",
  ROLEEXISTS: "Role already exists",
  FETCHVALIDATION:"First name and last name is empty, Please click fetch button to fetch User details.",
  SAVENOTIFICAIONUSER: "User added successfully",
  SAVENOTIFICAIONROLE: "Role added successfully",
  CONFIRM: "Confirm",
  CANCEL: "Cancel",
  CONFIRMSAVEUSER:"Do you want to save the user?",
  NODATA:"No data aviable. Click Add to create.",
  SAVEUSER: "Do you want to update the user?",
  SAVEROLE: "Do you want to update the role?",
  GENERALMESSAGE: "Something went wrong, please try again.",
};
